import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import {SkuDto} from './sku.dto'

export class AllSkuResponseModel extends GlobalResponseObject{
    data?: SkuDto[];
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data //ProductDto
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: SkuDto[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}